import L from "leaflet";
import groq from "groq";
import useSWR from "swr";
import MarkerClusterGroup from "react-leaflet-cluster";
import { MapContainer, Marker, TileLayer } from "react-leaflet";

import { DEFAULTS } from "../../data/defaults";
import sanityClient from "../../data/sanityClient";
import MapListener from "../MapListener";
import { useContext } from "react";
import UiContext from "../../context/UiContext";

function MapComponent() {
  const { openDialog } = useContext(UiContext);
  // const [lng, setLng] = useState(-70.9);
  // const [lat, setLat] = useState(42.35);
  // const [zoom, setZoom] = useState(9);

  const { data } = useSWR(groq`*[_type == "entry"]`, (query) =>
    sanityClient.fetch(query)
  );

  const myIcon = new L.Icon({
    iconUrl: DEFAULTS.marker_icon,
    popupAnchor: [-0, -0],
    iconSize: [32, 32],
  });

  // const locations = data

  return (
    <MapContainer
      center={DEFAULTS.initial_location}
      zoom={DEFAULTS.initial_zoom}
      scrollWheelZoom={true}
      zoomControl={false}
      style={{ height: "100vh" }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url={DEFAULTS.map_style}
      />

      <MarkerClusterGroup chunkedLoading>
        {data?.map((item: any) => (
          <Marker
            key={item._id}
            icon={myIcon}
            position={[item.location.lat, item.location.lng]}
            eventHandlers={{
              click: (e) => {
                openDialog({ name: "entry", id: item._id });
              },
            }}
          />
        ))}
      </MarkerClusterGroup>

      <MapListener />
    </MapContainer>
  );
}

export default MapComponent;
